import 'keen-slider/keen-slider.min.css'
import KeenSlider from 'keen-slider'

function navigation(slider) {
	let wrapper, arrowLeft, arrowRight, progressBarWrapper, progressBar
	let animationFrameId

	function markup(remove) {
		if (slider.track.details.slides.length > 1) {
			wrapperMarkup(remove)
			// dotMarkup(remove)
			arrowMarkup(remove)
			progressBarMarkup(remove)
		}
	}

	function removeElement(element) {
		element.parentNode.removeChild(element)
	}
	function createDiv(className) {
		var div = document.createElement('div')
		var classNames = className.split(' ')
		classNames.forEach(name => div.classList.add(name))
		return div
	}

	function arrowMarkup(remove) {
		if (remove) {
			removeElement(arrowLeft)
			removeElement(arrowRight)
			return
		}
		arrowLeft = createDiv('arrow arrow--left')
		arrowLeft.addEventListener('click', () => slider.prev())
		arrowRight = createDiv('arrow arrow--right')
		arrowRight.addEventListener('click', () => slider.next())

		wrapper.appendChild(arrowLeft)
		wrapper.appendChild(arrowRight)
	}

	function wrapperMarkup(remove) {
		if (remove) {
			if (!wrapper || !wrapper.parentNode) {
				return
			}
			// Move the slider container out of the wrapper
			wrapper.parentNode.insertBefore(slider.container, wrapper)
			// Remove the wrapper and all its children (dots, arrows, etc.)
			wrapper.parentNode.removeChild(wrapper)
			wrapper = null
			return
		}
		// Prevent re-wrapping
		if (wrapper) return

		wrapper = createDiv('navigation-wrapper')
		slider.container.parentNode.appendChild(wrapper)
		wrapper.appendChild(slider.container)
	}

	// function dotMarkup(remove) {
	// 	if (remove) {
	// 		removeElement(dots)
	// 		return
	// 	}
	// 	dots = createDiv('dots')
	// 	slider.track.details.slides.forEach((_e, idx) => {
	// 		var dot = createDiv('dot')
	// 		dot.addEventListener('click', () => slider.moveToIdx(idx))
	// 		dots.appendChild(dot)
	// 	})
	// 	wrapper.appendChild(dots)
	// }

	function progressBarMarkup(remove) {
		if (remove) {
			if (progressBarWrapper) removeElement(progressBarWrapper)
			return
		}
		if (!wrapper) return // wrapper must exist
		progressBarWrapper = createDiv('progress-bar-wrapper')
		progressBar = createDiv('progress-bar')
		progressBarWrapper.appendChild(progressBar)
		wrapper.appendChild(progressBarWrapper)
	}

	function updateProgressBar() {
		if (!slider || !progressBarWrapper || !progressBar) return
		const progress = slider.track.details.progress
		const containerWidth = progressBarWrapper.offsetWidth
		const barWidth = 50
		progressBar.style.width = `${barWidth}px`
		const moveDistance = containerWidth - barWidth
		const x = moveDistance * progress
		progressBar.style.transform = `translateX(${x}px)`
	}

	function animationLoop() {
		updateProgressBar()
		animationFrameId = requestAnimationFrame(animationLoop)
	}

	function updateClasses() {
		if (!wrapper || !arrowLeft || !arrowRight) return

		var slide = slider.track.details.rel
		slide === 0 ? arrowLeft.classList.add('arrow--disabled') : arrowLeft.classList.remove('arrow--disabled')
		slide === slider.track.details.slides.length - 1 ? arrowRight.classList.add('arrow--disabled') : arrowRight.classList.remove('arrow--disabled')
		// Array.from(dots.children).forEach(function (dot, idx) {
		// 	idx === slide ? dot.classList.add('dot--active') : dot.classList.remove('dot--active')
		// })
	}

	slider.on('created', () => {
		markup()
		updateClasses()
		updateProgressBar()
	})
	slider.on('optionsChanged', () => {
		console.log(2)
		markup(true)
		markup()
		updateClasses()
		updateProgressBar()
	})
	slider.on('slideChanged', () => {
		updateClasses()
		updateProgressBar()
	})
	slider.on('destroyed', () => {
		markup(true)
		if (animationFrameId) {
			cancelAnimationFrame(animationFrameId)
		}
	})

	slider.on('animationStarted', animationLoop)

	slider.on('animationEnded', () => {
		cancelAnimationFrame(animationFrameId)
		updateProgressBar()
	})

	slider.on('dragged', updateProgressBar)
}

export default function HeroCarousel() {
	return {
		carousel: null,
		init() {
			// Destroy existing instance to prevent HMR issues
			if (this.$el.keenSlider) {
				this.$el.keenSlider.destroy()
			}

			// Check if there are multiple slides before initializing
			const slides = this.$el.querySelectorAll('.keen-slider__slide')
			if (slides.length <= 1) {
				return // Don't initialize carousel for single or no slides
			}

			this.setupCarousel()

			// Add resize observer to handle initialization issues
			const resizeObserver = new ResizeObserver(() => {
				if (this.carousel) {
					this.carousel.update()
				}
			})

			resizeObserver.observe(this.$el)

			// Cleanup on disconnect
			this.$cleanup = () => {
				resizeObserver.disconnect()
				this.carousel?.destroy()
			}
		},

		setupCarousel() {
			if (!this.$el) return

			// Get slide count from DOM
			const slideCount = this.$el.querySelectorAll('.keen-slider__slide').length

			this.carousel = new KeenSlider(
				this.$el,
				{
					loop: false,
					drag: slideCount > 1,
					rubberband: true,
					dragSpeed: 1,
					slides: {
						perView: 1,
						spacing: 0,
					},
					created: () => {
						// console.log('created')
					},
				},
				[navigation],
			)

			// Store instance on element for HMR cleanup
			this.$el.keenSlider = this.carousel
		},

		onItemClick(index) {
			this.carousel?.moveToIdx(index)
		},
	}
}
